{
  "en": {
    "placeholders": {
      "name": "Name",
      "description": "Description",
      "amount": "Amount",
      "login": "Username or email",
      "username": "Username",
      "twoFactorCode": "Two-factor code",
      "confirmationCode": "Confirmation code",
      "email": "Email",
      "password": "Password",
      "passwordConfirmation": "Password Confirmation",
      "homepage": "Homepage",
      "discord": "Discord Server",
      "youtube": "Youtube Channel",
      "twitch": "Twitch Channel",
      "distance": "Distance",
      "guilded": "Guilded Server",
      "color": "Color",
      "title": "Title",
      "classification": "Combat, Industrial, Multi-Role...",
      "focus": "Light Fighter, Mining, Cargo...",
      "minSize": "snub, small, medium...",
      "maxSize": "medium, large, capital...",
      "minCrew": "Min. Crew",
      "minCargo": "SCU",
      "modelId": "Search for a ship",
      "scenario": "Xenothreat, Pirate Swarm, Bounty…",
      "briefing": "Detailed brief — comms, callsigns, rules of engagement…",
      "location": "Stanton, Pyro, ARC-L1…",
      "meetupLocation": "Daymar, Spaceport — Hangar 4…",
      "maxAttendees": "Optional cap",
      "autoLockMinutesBefore": "60",
      "timezone": "UTC",
      "startsAt": "Pick start date & time",
      "endsAt": "Pick end date & time (optional)",
      "notes": "Bringing extra ammo, can fly support, ETA in 10…",
      "signup-status": "Confirmed or tentative?",
      "features": {
        "username": "Username or User ID",
        "name": "Feature name"
      },
      "fleetInviteToken": "Fleet Invite",
      "quicksearch": {
        "models": "Avenger, Carrack, Cutlass...",
        "hangar": "Enterprise, Andromeda..."
      },
      "search": {
        "default": "Search...",
        "roadmap-progress-tracker": "Search"
      },
      "home": {
        "search": "Search for Ships..."
      },
      "image": {
        "caption": "Caption"
      },
      "model": {
        "length": "Length",
        "beam": "Beam",
        "height": "Height",
        "price": "Price",
        "pledgePrice": "Pledge Price",
        "onSale": "On Sale",
        "mass": "Mass",
        "minCrew": "Min. Crew",
        "maxCrew": "Max. Crew",
        "storeUrl": "Store URL",
        "salesPageUrl": "Sales Page URL",
        "rsiId": "RSI ID",
        "scKey": "SC Key",
        "erkulIdentifier": "Erkul Identifier",
        "productionNote": "Production Note",
        "scmSpeed": "SCM Speed",
        "scmSpeedBoosted": "SCM Speed Boosted",
        "maxSpeed": "Max Speed",
        "reverseSpeedBoosted": "Reverse Speed Boosted",
        "quantumFuelTankSize": "Quantum Fuel Tank Size",
        "hydrogenFuelTankSize": "Hydrogen Fuel Tank Size",
        "yaw": "Yaw",
        "pitch": "Pitch",
        "roll": "Roll",
        "yawBoosted": "Yaw Boosted",
        "pitchBoosted": "Pitch Boosted",
        "rollBoosted": "Roll Boosted",
        "fleetchartOffsetLength": "Fleetchart Offset Length",
        "fleetchartOffsetBeam": "Fleetchart Offset Beam",
        "extendedLength": "Extended Length",
        "extendedBeam": "Extended Beam",
        "extendedHeight": "Extended Height",
        "extendedFleetchartOffsetLength": "Extended Fleetchart Offset Length",
        "extendedFleetchartOffsetBeam": "Extended Fleetchart Offset Beam",
        "landedLength": "Landed Length",
        "landedBeam": "Landed Beam",
        "landedHeight": "Landed Height",
        "landedFleetchartOffsetLength": "Landed Fleetchart Offset Length",
        "landedFleetchartOffsetBeam": "Landed Fleetchart Offset Beam",
        "cargo": "Cargo",
        "baseModel": "Base Model"
      },
      "cargoHold": {
        "offsetX": "Offset X",
        "offsetY": "Offset Y",
        "offsetZ": "Offset Z",
        "rotation": "0 or 90"
      },
      "manufacturer": {
        "longName": "Long Name",
        "code": "Code",
        "scRef": "SC Ref"
      },
      "announcement": {
        "title": "What happened?",
        "body": "Markdown. Shown in the inbox and in the e-mail.",
        "discordPart": "One message",
        "socialPart": "One post",
        "link": "/fleets/"
      },
      "fundingGoal": {
        "title": "Server costs, Domain, Discord...",
        "description": "Optional context shown publicly",
        "amount": "100.00",
        "currency": "EUR",
        "effectiveFrom": "2026-01-01",
        "endedAt": "leave blank for ongoing"
      },
      "supporterContribution": {
        "name": "Supporter name shown publicly",
        "amount": "5.00",
        "currency": "EUR",
        "startedAt": "2026-01-01",
        "endedAt": "2026-12-31",
        "payerEmail": "donor@example.com",
        "claimKey": "FY-7K2M-9QXD",
        "note": "Optional internal note"
      },
      "component": {
        "componentClass": "Component Class",
        "componentType": "Component Type",
        "componentSubType": "Component Sub Type",
        "itemType": "Item Type",
        "size": "Size",
        "grade": "Grade",
        "scKey": "SC Key",
        "scRef": "SC Ref"
      },
      "modelPaint": {
        "pledgePrice": "Pledge Price",
        "productionStatus": "Production Status",
        "productionNote": "Production Note"
      },
      "fleet": {
        "headquarters": "Where is your fleet based?",
        "fid": "Fleet ID",
        "rsiSid": "RSI SID",
        "ts": "Teamspeak Server",
        "description": "Description",
        "guilded": "Guilded Server",
        "homepage": "Homepage",
        "twitch": "Twitch Channel",
        "youtube": "Youtube Channel",
        "discord": {
          "guildId": "e.g. 123456789012345678",
          "channelId": "Voice channel ID for the event",
          "webhookUrl": "https://discord.com/api/webhooks/…",
          "webhookConfigured": "Saved — leave empty to keep the existing one"
        }
      },
      "adminUser": {
        "passwordConfirmation": "Password Confirmation"
      },
      "user": {
        "rsiHandle": "RSI Handle",
        "location": "e.g. Berlin, Germany",
        "currentSystem": "e.g. Lorville, Port Tressler, Pyro"
      },
      "oauthApplication": {
        "name": "My Application",
        "redirectUri": "https://example.com/callback",
        "scopes": "public"
      },
      "vehicle": {
        "serial": "Serial (XX-XXXX-XX)"
      },
      "itemPrice": {
        "price": "0.00",
        "location": "Location",
        "locationUrl": "Location URL"
      },
      "video": {
        "url": "YouTube Video ID"
      },
      "modelModule": {
        "name": "Module Name",
        "price": "0.00",
        "pledgePrice": "0.00",
        "productionStatus": "Announced, Flight Ready, In Concept...",
        "scKey": "SC Key",
        "search": "Search modules by name..."
      },
      "modelUpgrade": {
        "name": "Upgrade Name",
        "pledgePrice": "0.00",
        "description": "Description"
      },
      "modelModulePackage": {
        "name": "Package Name",
        "pledgePrice": "0.00",
        "description": "Description"
      },
      "dock": {
        "name": "Dock Name",
        "length": "Length in m",
        "beam": "Beam in m",
        "height": "Height in m"
      },
      "modelPosition": {
        "name": "Position Name",
        "position": "0"
      },
      "logistics": {
        "inventoryName": "Main Depot, Cargo Bay...",
        "description": "Optional details about this inventory",
        "location": "e.g. Port Olisar, Area18",
        "itemName": "Titanium, Medical Supplies..."
      },
      "filters": {
        "vehicles": {
          "name": "Enterprise, Andromeda...",
          "priceLt": "Price <=",
          "priceGt": "Price >="
        },
        "models": {
          "name": "Gladius, Andromeda...",
          "classification": "Vehicle, Fighter, Cargo...",
          "manufacturer": "Origin, Robert Space Industries, Aegis...",
          "onSale": "Yes or No",
          "productionStatus": "Announced, Flight Ready, In Concept..."
        },
        "modelModules": {
          "name": "Bio Dome, Cargo Module..."
        },
        "manufacturers": {
          "name": "Origin, Robert Space Industries, Aegis..."
        },
        "supporterContributions": {
          "name": "Alice, Bob...",
          "startedAtGteq": "2026-01-01",
          "startedAtLteq": "2026-12-31"
        },
        "adminNotifications": {
          "search": "Title or content..."
        },
        "users": {
          "search": "Username or Email",
          "username": "Username",
          "rsiHandle": "RSI Handle",
          "email": "Email"
        },
        "components": {
          "name": "Name",
          "description": "quantum drive, armor plating...",
          "manufacturer": "Behring, Ascension Astro, Juno Starwerk..."
        },
        "fleets": {
          "name": "Name",
          "fid": "FID",
          "memberCountGteq": "Minimum members",
          "memberCountLteq": "Maximum members",
          "createdOnGteq": "2026-01-01",
          "createdOnLteq": "2026-12-31",
          "members": {
            "search": "Username or nickname"
          }
        },
        "destroyedFleets": {
          "nameOrFid": "Name or FID"
        },
        "commodities": {
          "name": "Agricium, Laranite, Quantainium...",
          "description": "ore, ammunition, material...",
          "uexCode": "UEX Code"
        },
        "equipment": {
          "name": "Arclight, Pembroke, Novikov..."
        },
        "notifications": {
          "search": "Title or content..."
        },
        "blueprints": {
          "name": "Greatsword, Testudo, Omnisky...",
          "material": "Iron, Titanium, Aphorite...",
          "craftableType": "Component, Equipment...",
          "source": "Known, unknown..."
        },
        "fleetDirectory": {
          "search": "Name, FID or SID...",
          "memberCountGteq": "Minimum members"
        }
      },
      "commodity": {
        "commodityType": "Commodity Type",
        "uexId": "UEX ID",
        "uexCode": "UEX Code",
        "scKey": "SC Key",
        "scRef": "SC Ref"
      },
      "equipment": {
        "equipmentType": "Equipment Type",
        "itemType": "Item Type",
        "subType": "Sub Type",
        "weaponClass": "Weapon Class",
        "size": "Size",
        "grade": "Grade",
        "scKey": "SC Key",
        "scRef": "SC Ref"
      },
      "relationships": {
        "user": {
          "handle": "Their username"
        },
        "fleet": {
          "handle": "Their fleet slug"
        }
      },
      "reward": "Reward in aUEC",
      "crewLimit": "No limit",
      "deadline": "No deadline",
      "itemName": "What to deliver",
      "itemQuantity": "How much",
      "itemQuality": "600"
    }
  }
}
